import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { AccountListWebScreen } from '@/features/account-management/screens/list/AccountListWeb.screen';
import { AccountListMobileScreen } from '@/features/account-management/screens/list/AccountListMobile.screen';

export interface AccountListProps {}

export const AccountListScreen: React.FC<AccountListProps> = () => {
  const layout = useContext(LayoutContext);
  if (layout.isMobile) {
    return <AccountListMobileScreen />;
  }

  return <AccountListWebScreen />;
};
